import { PaymentMethodTypeEnum } from '@bondsports/types';
import { Ach, CreditCard, Cash, Check, Icon, DollarAmount, CreditBalance, GiftCard } from '@components/atoms';
import { Text } from '@components/atoms';

interface PaymentLabelProps {
	paymentType?: PaymentMethodTypeEnum;
	labels: Partial<Record<PaymentMethodTypeEnum, string>>;
}

const paymentTypeToIcon: Partial<Record<PaymentMethodTypeEnum, React.ReactElement>> = {
	[PaymentMethodTypeEnum.ACH]: <Ach />,
	[PaymentMethodTypeEnum.BALANCE]: <CreditBalance />,
	[PaymentMethodTypeEnum.CASH]: <Cash />,
	[PaymentMethodTypeEnum.CHECK]: <Check />,
	[PaymentMethodTypeEnum.CARD]: <CreditCard />,
	[PaymentMethodTypeEnum.CARD_ON_TERMINAL]: <CreditCard />,
	[PaymentMethodTypeEnum.GIFT_CARD]: <GiftCard />,
	[PaymentMethodTypeEnum.OTHER]: <DollarAmount />,
};

const getIcon = (paymentType: PaymentMethodTypeEnum) => {
	return paymentTypeToIcon[paymentType] ?? <DollarAmount />;
};

export const PaymentLabel = ({ paymentType = PaymentMethodTypeEnum.OTHER, labels }: PaymentLabelProps) => {
	return (
		<div className="flex flex-row items-center gap-1">
			<Icon size="md" color="element">
				{getIcon(paymentType)}
			</Icon>
			<Text size="xs">{labels[paymentType]}</Text>
		</div>
	);
};
